import {
  NgbModal,
  NgbModalOptions,
  NgbModalRef,
} from '@ng-bootstrap/ng-bootstrap';
import { Injectable, Type } from '@angular/core';

export interface SbModalOptions extends NgbModalOptions {
  blurBackdrop?: boolean;
  blurAmount?: string; // e.g., '4px', '8px', '12px'
}

@Injectable({
  providedIn: 'root',
})
export class SbModalService {
  private modalOpen = false;

  constructor(private modalService: NgbModal) {}

  isModalOpen(): boolean {
    return this.modalOpen;
  }

  openModal(
    componentToBeLoad: Type<any>,
    size: any = 'md',
    options?: SbModalOptions,
  ): NgbModalRef {
    const blurBackdrop = options?.blurBackdrop ?? true;
    const blurAmount = options?.blurAmount ?? '6px';
    const centerModal = options?.centered ?? false;

    const computedBackdropClass = blurBackdrop ? 'blur-backdrop' : '';

    if (blurBackdrop) {
      document.documentElement.style.setProperty(
        '--modal-blur-amount',
        blurAmount,
      );
    }

    const modalRef = this.modalService.open(componentToBeLoad, {
      backdrop: 'static',
      keyboard: false,
      animation: true,
      size,
      centered: centerModal,
      backdropClass:
        `${computedBackdropClass} ${options?.backdropClass ?? ''}`.trim(),
      windowClass: `custom-modal-window ${options?.windowClass ?? ''}`.trim(),
      ...options,
    });

    this.trackModal(modalRef);
    return modalRef;
  }

  openModalWithSingleData(
    componentToBeLoad: Type<any>,
    size: any = 'lg',
    data: any,
    options?: SbModalOptions,
  ): NgbModalRef {
    const modalRef = this.openModal(componentToBeLoad, size, options);
    Object.assign(modalRef.componentInstance, data);
    return modalRef;
  }

  closeModal(message?: any) {
    this.modalService.dismissAll(message);
    this.modalOpen = false;
  }

  private trackModal(modalRef: NgbModalRef) {
    this.modalOpen = true;
    modalRef.result.then(
      () => (this.modalOpen = false),
      () => (this.modalOpen = false),
    );
  }
}
